function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Add-text-component",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.2_add-text-component",
  transform: "translate(-982.000000, -248.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-media-bar",
  transform: "translate(939.000000, 240.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.875,24.6328125 C59.4375,24.6328125 60.234375,23.8515625 60.234375,22.3046875 L60.234375,14.4453125 C60.234375,12.90625 59.4375,12.1171875 57.875,12.1171875 L56.5078125,12.1171875 L56.5078125,10.9296875 C56.5078125,9.3828125 55.7109375,8.6015625 54.1484375,8.6015625 L46.2421875,8.6015625 C44.671875,8.6015625 43.8828125,9.3828125 43.8828125,10.9296875 L43.8828125,18.71875 C43.8828125,20.265625 44.671875,21.046875 46.2421875,21.046875 L47.609375,21.046875 L47.609375,22.3046875 C47.609375,23.8515625 48.3984375,24.6328125 49.96875,24.6328125 L57.875,24.6328125 Z M47.609375,19.765625 L46.2890625,19.765625 C45.5703125,19.765625 45.171875,19.3828125 45.171875,18.6328125 L45.171875,11.015625 C45.171875,10.265625 45.5703125,9.8828125 46.2890625,9.8828125 L54.1015625,9.8828125 C54.8203125,9.8828125 55.21875,10.265625 55.21875,11.015625 L55.21875,12.1171875 L49.96875,12.1171875 C48.3984375,12.1171875 47.609375,12.8984375 47.609375,14.4453125 L47.609375,19.765625 Z M57.828125,23.3515625 L50.0078125,23.3515625 C49.2890625,23.3515625 48.890625,22.96875 48.890625,22.21875 L48.890625,14.53125 C48.890625,13.78125 49.2890625,13.3984375 50.0078125,13.3984375 L57.828125,13.3984375 C58.5390625,13.3984375 58.9453125,13.78125 58.9453125,14.53125 L58.9453125,22.21875 C58.9453125,22.96875 58.5390625,23.3515625 57.828125,23.3515625 Z M53.9375,21.453125 C54.2578125,21.453125 54.515625,21.1953125 54.515625,20.84375 L54.515625,18.96875 L56.3515625,18.96875 C56.71875,18.96875 57,18.6875 57,18.359375 C57,18.0390625 56.71875,17.765625 56.3515625,17.765625 L54.515625,17.765625 L54.515625,15.8984375 C54.515625,15.546875 54.2578125,15.2890625 53.9375,15.2890625 C53.609375,15.2890625 53.3515625,15.546875 53.3515625,15.8984375 L53.3515625,17.765625 L51.453125,17.765625 C51.125,17.765625 50.8359375,18.0546875 50.8359375,18.359375 C50.8359375,18.6875 51.125,18.96875 51.453125,18.96875 L53.3515625,18.96875 L53.3515625,20.84375 C53.3515625,21.1953125 53.609375,21.453125 53.9375,21.453125 Z",
  id: "duplicate"
}))));

function SvgIconDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "duplicate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicate);
export default __webpack_public_path__ + "static/media/icon_duplicate.db6a00d8.svg";
export { ForwardRef as ReactComponent };